import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { version } from './version';
import { ThemeProvider } from './context/ThemeContext';

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container as HTMLElement);
  root.render(
    <ThemeProvider>
      <App />
    </ThemeProvider>
  );
}

// eslint-disable-next-line no-console
console.log('App version', version);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
